import dayjs from "dayjs";
import { DesktopDatePicker, DesktopDateTimePicker } from "@mui/x-date-pickers";

/**
 * Single date/date-time field on top of MUI X (already wired via the
 * LocalizationProvider/AdapterDayjs set up in pageRoutes.jsx). Talks native
 * `Date` in and out so callers don't need to know dayjs exists.
 */
export const DateField = ({
  value,
  onChange,
  showTime = false,
  label,
  ariaLabel,
  size = "small",
  error,
  helperText,
  minDate,
  maxDate,
  disabled = false,
  className = ""
}) => {
  const Picker = showTime ? DesktopDateTimePicker : DesktopDatePicker;

  return (
    <div className={className}>
      <Picker
        label={label}
        value={value ? dayjs(value) : null}
        onChange={newValue => onChange?.(newValue ? newValue.toDate() : null)}
        minDate={minDate ? dayjs(minDate) : undefined}
        maxDate={maxDate ? dayjs(maxDate) : undefined}
        disabled={disabled}
        slotProps={{
          textField: {
            size,
            error,
            helperText,
            fullWidth: true,
            inputProps: ariaLabel ? { "aria-label": ariaLabel } : undefined
          }
        }}
      />
    </div>
  );
};

export default DateField;
